"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";
import { LogOut, RefreshCw } from "lucide-react";
import { invalidarCacheCliente } from "@/lib/fetch-cache-cliente";
import { MenuItem } from "./Menu";

export function SairButton({ variant = "icon" }: { variant?: "icon" | "menu" }) {
  const router = useRouter();
  const [saindo, setSaindo] = useState(false);

  async function sair() {
    setSaindo(true);
    try {
      await fetch("/api/logout", { method: "POST" });
    } catch {}
    invalidarCacheCliente();
    router.push("/login");
    router.refresh();
  }

  if (variant === "menu") {
    return (
      <MenuItem onSelect={sair} disabled={saindo} className="gap-2 px-3 py-2 text-sm">
        {saindo ? <RefreshCw aria-hidden="true" className="h-4 w-4 animate-spin" /> : <LogOut aria-hidden="true" className="h-4 w-4" />}
        {saindo ? "Saindo..." : "Sair"}
      </MenuItem>
    );
  }

  return (
    <button
      onClick={sair}
      disabled={saindo}
      title="Sair"
      className="flex h-11 w-11 items-center justify-center rounded-xl border border-border text-muted transition-colors hover:border-red-200 hover:text-red-500 disabled:opacity-60"
    >
      {saindo ? <RefreshCw className="h-[18px] w-[18px] animate-spin" /> : <LogOut className="h-[18px] w-[18px]" />}
    </button>
  );
}
